var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery } from '@tanstack/react-query';
import React, { createContext, useCallback, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { RequestLoadingIndicator } from '../../../components/RequestLoadingIndicator';
import { SituacaoProcessoEnum } from '../../../enums/situacao-processo.enum';
import { findAnaliseByProcessoId } from '../../../services/analise-processo.service';
import { addFuncionarioInProcesso, removeFuncionarioInProcesso, updateFuncionarioInProcesso, } from '../../../services/processo-funcionario.service';
import { addSocioInProcesso, removeSocioInProcesso, updateSocioInProcesso, } from '../../../services/processo-socio.service';
import { addVeiculoInProcesso, removeVeiculoInProcesso, updateVeiculoInProcesso, } from '../../../services/processo-veiculo.service';
import { getProcessoById, getServicoCredenciamentoByProcessoId, updateDocumentosEmpresa as apiUpdateDocumentosEmpresa, updateEmpresaInProcesso, } from '../../../services/processo.service';
import { addOperadorInProcesso, updateOperadorInProcesso, removeOperadorInProcesso, } from '../../../services/processo-operador.service';
var ProcessContext = createContext(undefined);
export var ProcessProvider = function (_a) {
    var children = _a.children;
    var params = useParams();
    var processoId = params.id ? Number(params.id) : undefined;
    var _b = useQuery({
        queryKey: ['processo', processoId],
        queryFn: function () { return getProcessoById(processoId); },
        enabled: !!processoId,
    }), processo = _b.data, isFetchingProcesso = _b.isLoading, refetchProcesso = _b.refetch;
    var _c = useQuery({
        queryKey: ['servico', processoId],
        queryFn: function () { return getServicoCredenciamentoByProcessoId(processoId); },
        enabled: !!processoId,
    }), servico = _c.data, isFetchingServico = _c.isLoading;
    var _d = useQuery({
        queryKey: ['analise', processoId],
        queryFn: function () { return findAnaliseByProcessoId(processoId); },
        enabled: !!processo &&
            ((processo === null || processo === void 0 ? void 0 : processo.situacao) === SituacaoProcessoEnum.APROVADO ||
                (processo === null || processo === void 0 ? void 0 : processo.situacao) === SituacaoProcessoEnum.PENDENTE ||
                (processo === null || processo === void 0 ? void 0 : processo.situacao) === SituacaoProcessoEnum.REPROVADO),
    }), analise = _d.data, isFetchingAnalise = _d.isLoading;
    var _e = useState(0), mutatingCount = _e[0], setMutatingCount = _e[1];
    var isMutating = mutatingCount > 0;
    var updateEmpresaMutation = useMutation({
        mutationFn: function (data) {
            return updateEmpresaInProcesso(processoId, data);
        },
        onSuccess: function () {
            refetchProcesso();
        },
    });
    var updateEmpresa = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, updateEmpresaMutation.mutateAsync(data)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var updateDocumentosByEmpresa = useCallback(function (documentos) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, apiUpdateDocumentosEmpresa(processoId, documentos)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var addOperador = useCallback(function (operador) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, addOperadorInProcesso(processoId, operador)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var updateOperador = useCallback(function (operadorId, operador) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, updateOperadorInProcesso(processoId, operadorId, operador)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var deleteOperador = useCallback(function (operadorId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, removeOperadorInProcesso(processoId, operadorId)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var addFuncionario = useCallback(function (funcionario) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, addFuncionarioInProcesso(processoId, funcionario)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var updateFuncionario = useCallback(function (funcionarioId, funcionario) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, updateFuncionarioInProcesso(processoId, funcionarioId, funcionario)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var deleteFuncionario = useCallback(function (funcionarioId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, removeFuncionarioInProcesso(processoId, funcionarioId)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var addSocio = useCallback(function (socio) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, addSocioInProcesso(processoId, socio)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var updateSocio = useCallback(function (socioId, socio) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, updateSocioInProcesso(processoId, socioId, socio)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var deleteSocio = useCallback(function (socioId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, removeSocioInProcesso(processoId, socioId)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var addVeiculo = useCallback(function (veiculo) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, addVeiculoInProcesso(processoId, veiculo)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var updateVeiculo = useCallback(function (veiculoId, veiculo) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, updateVeiculoInProcesso(processoId, veiculoId, veiculo)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var deleteVeiculo = useCallback(function (veiculoId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutatingCount(function (c) { return c + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, removeVeiculoInProcesso(processoId, veiculoId)];
                case 2:
                    _a.sent();
                    refetchProcesso();
                    return [3 /*break*/, 4];
                case 3:
                    setMutatingCount(function (c) { return c - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [processoId, refetchProcesso]);
    var isLoading = isFetchingProcesso ||
        isFetchingServico ||
        isFetchingAnalise ||
        isMutating;
    return (_jsxs(ProcessContext.Provider, { value: {
            servico: servico,
            processo: processo,
            analise: analise,
            updateEmpresa: updateEmpresa,
            updateDocumentosByEmpresa: updateDocumentosByEmpresa,
            addOperador: addOperador,
            updateOperador: updateOperador,
            deleteOperador: deleteOperador,
            addSocio: addSocio,
            updateSocio: updateSocio,
            deleteSocio: deleteSocio,
            addVeiculo: addVeiculo,
            updateVeiculo: updateVeiculo,
            deleteVeiculo: deleteVeiculo,
            addFuncionario: addFuncionario,
            updateFuncionario: updateFuncionario,
            deleteFuncionario: deleteFuncionario,
            isEditable: !!processo &&
                (processo.situacao === SituacaoProcessoEnum.RASCUNHO ||
                    processo.situacao === SituacaoProcessoEnum.PENDENTE),
            isLoading: isLoading,
        }, children: [_jsx(RequestLoadingIndicator, { loading: isLoading }), !isLoading && children] }));
};
export var useProcessContext = function () {
    var context = useContext(ProcessContext);
    if (!context) {
        throw new Error('useProcessContext must be used within a ProcessProvider');
    }
    return context;
};
